import { Button } from "shared/ui/button";
import { useMobile } from "shared/lib/hooks";
import Enesthetica from "../assets/Enesthetica.svg";
import Academie from "../assets/Academie.png";
import Lotos from "../assets/LotosUnited.svg";
import Cortexil from "../assets/Cortexil.png";
import Globeart from "../assets/Globeart.png";
import Dermacte from "../assets/Dermacte.svg";
import Kntech from "../assets/Kntech.svg";
import styles from "./PartnersSection.module.scss";

export const PartnersSection = () => {
  const isTablet = useMobile("950px");
  return (
    <div className={styles.brandsContainer}>
      <p className={styles.brandsContainer__title}>Партнеры мероприятия</p>
      <div className={styles.brandsContainer__tables}>
        {isTablet ? (
          <div className={styles.brandsWrapperTablet}>
            <div className={styles.brandsWrapperTablet__brand}>
              <img
                src={Enesthetica}
                className={styles.brandImg}
                alt="Enesthetica"
              />
            </div>
            <div className={styles.brandsWrapperTablet__brand}>
              <img src={Academie} className={styles.brandImg} alt="Academie" />
            </div>
            <div className={styles.brandsWrapperTablet__brand}>
              <img src={Lotos} className={styles.brandImg} alt="Lotos" />
            </div>
            <div className={styles.brandsWrapperTablet__brand}>
              <img src={Cortexil} className={styles.brandImg} alt="Cortexil" />
            </div>
            <div className={styles.brandsWrapperTablet__brand}>
              <img src={Globeart} className={styles.brandImg} alt="Globeart" />
            </div>
            <div className={styles.brandsWrapperTablet__brand}>
              <img src={Dermacte} className={styles.brandImg} alt="Dermacte" />
            </div>
            <div className={styles.brandsWrapperTablet__brand}>
              <img src={Kntech} className={styles.brandImg} alt="Kntech" />
            </div>
          </div>
        ) : (
          <>
            <div className={styles.brandsWrapperLeft}>
              <div
                className={`${styles.brandsWrapperLeft__brand} ${styles.brandsWrapperLeft__brand1}`}
              >
                <img
                  src={Enesthetica}
                  className={styles.brandImgLarge}
                  alt="Enesthetica"
                />
              </div>
            </div>
            <div className={styles.brandsWrapperRight}>
              <div
                className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand8}`}
              >
                <img
                  src={Academie}
                  className={styles.brandImgSmall}
                  alt="Academie"
                />
              </div>
              <div
                className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand9}`}
              >
                <img src={Lotos} className={styles.brandImgSmall} alt="Lotos" />
              </div>
              <div
                className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand11}`}
              >
                <img
                  src={Cortexil}
                  className={styles.brandImgSmall}
                  alt="Cortexil"
                />
              </div>
              <div
                className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand10}`}
              >
                <img
                  src={Globeart}
                  className={styles.brandImgSmall}
                  alt="Globeart"
                />
              </div>
              <div
                className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand12}`}
              >
                <img
                  src={Dermacte}
                  className={styles.brandImgSmall}
                  alt="Dermacte"
                />
              </div>
              <div
                className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand13}`}
              >
                <img
                  src={Kntech}
                  className={styles.brandImgSmall}
                  alt="Kntech"
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
